export const MAP_STYLES = {
  satellite: {
    name: 'Esri Satellite',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: '&copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
  },
  osm: {
    name: 'OpenStreetMap',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; OSM contributors'
  },
  positron: {
    name: 'Carto Positron',
    url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
    attribution: '&copy; OpenStreetMap &copy; CARTO'
  },
  dark: {
    name: 'Carto Dark Matter',
    url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
    attribution: '&copy; OpenStreetMap &copy; CARTO'
  },
  esriStreets: {
  name: 'Esri Streets',
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
  attribution: '&copy; Esri'
},
esriTopo: {
  name: 'Esri Topographic',
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
  attribution: '&copy; Esri'
},
topo: {
  name: 'OpenTopoMap',
  url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
  attribution: '&copy; OpenTopoMap contributors'
},
stamenToner: {
  name: 'Stamen Toner',
  url: 'https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}{r}.png',
  attribution: '&copy; Stamen & OpenStreetMap'
},
stamenWatercolor: {
  name: 'Stamen Watercolor',
  url: 'https://tiles.stadiamaps.com/tiles/stamen_watercolor/{z}/{x}/{y}.jpg',
  attribution: '&copy; Stamen & OpenStreetMap'
},
hot: {
  name: 'OSM Humanitarian',
  url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
  attribution: '&copy; OpenStreetMap contributors, HOT'
},
cartoNoLabels: {
  name: 'Carto Positron (No Labels)',
  url: 'https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png',
  attribution: '&copy; OpenStreetMap &copy; CARTO'
},
natGeo: {
  name: 'NatGeo',
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}',
  attribution: '&copy; Esri & National Geographic'
},
nasaGIBS: {
  name: 'NASA GIBS',
  url: 'https://map1.vis.earthdata.nasa.gov/wmts-webmerc/VIIRS_CityLights_2012/default/GoogleMapsCompatible_Level8/{z}/{y}/{x}.jpg',
  attribution: '&copy; NASA'
},
geoPortail: {
    name: 'Géoportail',
    url: 'https://data.geopf.fr/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/jpeg&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}',
    attribution: '&copy; IGN France'
    },
landscape: {
    name: 'Landscape',
    url: 'https://api.maptiler.com/maps/landscape-v4/{z}/{x}/{y}.png?key=BBLcVgcVPwuTT1KpXYAm',
    attribution: '&copy; Stamen & OpenStreetMap'
  }
};